export const styles = {
  listItem: {
    display: 'list-item',
    listStyleType: 'disc',
    ml: 2,
  },
};
